import { resolveMediaUrl } from "@utils/media/mediaUrl";

export function normalizeTranslationValue(entry) {
  if (typeof entry === "string") return entry;
  if (entry && typeof entry === "object") return entry.value || "";
  return "";
}

export function normalizeTranslationMap(map = {}) {
  return Object.entries(map || {}).reduce((acc, [iso, entry]) => {
    acc[iso] = normalizeTranslationValue(entry);
    return acc;
  }, {});
}

export function normalizeTranslationIds(map = {}) {
  return Object.entries(map || {}).reduce((acc, [iso, entry]) => {
    acc[iso] = entry && typeof entry === "object" ? entry.id || "" : "";
    return acc;
  }, {});
}

export function buildLanguageList(languages = []) {
  return languages
    .map((language) => ({
      id: language.lng_id || language.id,
      iso: (language.lng_iso || language.iso || "").toLowerCase(),
      name: language.lng_name || language.name || "",
    }))
    .filter((language) => language.iso);
}

export function pickDraftTourName(nameByLang = {}) {
  const en = normalizeTranslationValue(nameByLang.en);
  const es = normalizeTranslationValue(nameByLang.es);
  const pt = normalizeTranslationValue(nameByLang.pt);
  const fallback = normalizeTranslationValue(Object.values(nameByLang)[0]);
  return en || es || pt || fallback || "";
}

export function pickTourName(tour) {
  const names = tour?.name || tour?.description?.name || {};
  const en = normalizeTranslationValue(names.en);
  const es = normalizeTranslationValue(names.es);
  const pt = normalizeTranslationValue(names.pt);
  const fallback = normalizeTranslationValue(Object.values(names)[0]);
  return en || es || pt || fallback || "Untitled";
}

export function pickTourBannerUrl(tour) {
  const raw =
    tour?.bannerUrl ||
    tour?.banner?.url ||
    tour?.description?.bannerUrl ||
    tour?.description?.banner?.url ||
    "";
  return resolveMediaUrl(raw);
}

export function resolveTourId(tour) {
  return tour?.id || tour?.tur_id || tour?.tourId || tour?.code || "";
}
